var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticStyle:{"display":"none"},attrs:{"id":"home-canvas6","src":require('@/assets/home/home-canvas6.png'),"alt":""}}),_c('canvas',{attrs:{"id":"myCanvas","width":"1200","height":"666"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }